import { FilterTypeEnum, GridFilter } from '../..';
import { FilterDropdownProps } from '../AntTableInterfaces/Interfaces';

export const SearchFilterName = 'SearchFilter';

// Search Filter Condition
export enum FilterConditionEnum {
  NONE = 'None',
  AND = 'AND',
  OR = 'OR',
}

// Search Filter Options
export enum FilterOptionEnum {
  CONTAINS = 'contains',
  NOT_CONTAINS = 'notContains',
  EQUALS = 'equals',
  NOT_EQUALS = 'notEquals',
  STARTS_WITH = 'startsWith',
  ENDS_WITH = 'endsWith',
  IS_EMPTY = 'isEmpty',
  IS_NOT_EMPTY = 'isNotEmpty',
  LESS_THAN = 'lessThan',
  LESS_THAN_OR_EQUALS = 'lessThanOrEquals',
  GREATER_THAN = 'greaterThan',
  GREATER_THAN_OR_EQUALS = 'greaterThanOrEquals',
  IS_NULL = 'isNull',
  IS_NOT_NULL = 'isNotNull',
  IN_RANGE_INCLUDED = 'inRangeIncluded',
  IN_RANGE_EXCLUDED = 'inRangeExcluded',
  IN_RANGE = 'inRange',
}

// Search Filter Definition
export interface SearchFilterType {
  name: 'SearchFilter';
  version: 1,
  type: FilterTypeEnum;
  option1: FilterOptionEnum;
  valueFrom1: string;
  valueTo1: string;
  joinCondition: FilterConditionEnum;
  option2: FilterOptionEnum;
  valueFrom2: string;
  valueTo2: string;
  isTimestamp: boolean;
}

// Get the Search Filter as a stringified JSON Object
export const getSearchFilterAsString = (
  type: FilterTypeEnum,
  option1: FilterOptionEnum,
  valueFrom1: string,
  valueTo1: string = null,
  joinCondition: FilterConditionEnum = FilterConditionEnum.NONE,
  option2: FilterOptionEnum = null,
  valueFrom2: string = null,
  valueTo2: string = null,
  isTimestamp = false,
) : string => {
  const searchFilter: SearchFilterType = {
    name: SearchFilterName,
    version: 1,
    type,
    option1,
    valueFrom1,
    valueTo1,
    joinCondition,
    option2,
    valueFrom2,
    valueTo2,
    isTimestamp,
  };

  return JSON.stringify(searchFilter);
};

// Get the Search Filter from a stringified JSON Object
export const getSearchFilterAsObject = (searchFilterString: string): SearchFilterType => {
  if (searchFilterString) {
    const searchFilter: SearchFilterType = JSON.parse(searchFilterString);

    // Check if Filter is a Search Filter
    if (searchFilter.name === SearchFilterName) {
      return searchFilter;
    }
  }

  return null;
};

// Get the Select Filter From Filters
export const getSearchFilterFromFilters = (filters: GridFilter[], column: string): SearchFilterType => {
  // Find the correct Filter
  const filter: GridFilter = filters?.filter((filterItem) => filterItem.column === column)[0];

  if (filter) {
    return getSearchFilterAsObject(filter.value);
  }

  return null;
};

interface SearchFilterProps {
  title: string;
  dataIndex: string;
  filterType: FilterTypeEnum;
  props: FilterDropdownProps;
  intputPrefix?: React.ReactNode;
  includeNullOrEmpty?: boolean;
  dateFormat?: string; // https://momentjs.com/docs/#/parsing/string-format/
  isTimestamp?: boolean; // The Dates also contains a Timestamp. Convert the Filter to a Date range spanning the Full Day.  Used by Created column
  minimum?: number; // Number & Decimal only
  maximum?: number; // Number & Decimal only
}

export default SearchFilterProps;
